<template>
	<div class="yjfk-page">
		<!-- 历史反馈记录入口 -->
		<div class="card menu-card" @click="goHistory">
			<div class="menu-left">
				<van-icon name="clock-o" class="menu-icon" />
				<span>历史反馈记录</span>
			</div>
			<van-icon name="arrow" class="menu-arrow" />
		</div>
		<div class="card">
			<!-- 问题类型 -->
			<div class="sec">
				<div class="sec-title"><span class="req">*</span>问题类型</div>
				<div class="tags">
					<div class="tag" :class="{ active: form.type === item.id }" v-for="(item, i) in types" :key="i"
						@click="chooseType(item)">{{ item.text }}</div>
				</div>
			</div>
			<!-- 补充说明 -->
			<div class="sec">
				<div class="sec-title">补充说明</div>
				<van-field v-model="form.content" class="content-field" type="textarea" :rows="4" autosize maxlength="500"
					show-word-limit placeholder="请对您想说明的内容进行尽可能详细的描述：" />
			</div>
			<!-- 截图上传 -->
			<div class="sec">
				<div class="sec-title">请提供相关问题的截图或照片<span class="count">({{ attachs.length }}/4)</span></div>
				<van-uploader v-model="attachs" :max-count="4" multiple :after-read="afterRead" />
			</div>
			<!-- 联系方式 -->
			<div class="sec">
				<div class="sec-title">联系方式</div>
				<div class="contact-row" v-if="!editingContact" @click="editingContact = true">
					<span class="phone" :class="{ empty: !form.contact }">{{ maskedPhone || '请输入联系方式' }}</span>
					<van-icon name="edit" class="edit-icon" />
				</div>
				<van-field v-else v-model="form.contact" class="contact-field" type="tel" maxlength="11"
					placeholder="请输入手机号" @blur="editingContact = false" />
			</div>
		</div>
		<div class="submit-wrap">
			<van-button round block :disabled="!canSubmit" :class="canSubmit ? 'btnblue' : 'btn-gray'"
				@click="onSubmit">提交</van-button>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex';
	export default {
		data() {
			return {
				//问题类型,先给默认值,进页面后从字典接口刷新
				types: [{
					id: '1',
					text: '功能异常'
				}, {
					id: '2',
					text: '产品建议'
				}, {
					id: '3',
					text: '安全分类'
				}, {
					id: '4',
					text: '其它问题'
				}],
				form: {
					type: '', //选中的问题类型(字典值)
					name: '', //姓名,后端必填,默认带出登录用户
					content: '', //补充说明
					contact: '' //联系方式
				},
				attachs: [], //已上传的截图
				editingContact: false //联系方式编辑中
			};
		},
		computed: {
			...mapState(['userInfo']),
			//选中类型且填写说明后才可提交
			canSubmit() {
				return this.form.type !== '' && this.form.content.trim() !== '';
			},
			//手机号脱敏展示 151****7705
			maskedPhone() {
				const p = this.form.contact;
				if (p && /^1\d{10}$/.test(p)) {
					return p.slice(0, 3) + '****' + p.slice(7);
				}
				return p || '';
			},
			//当前默认房屋的小区id,上报时后端必填
			villageId() {
				const houses = this.userInfo.houses || [];
				const house = houses.find(item => item.isDefault) || houses[0];
				return house && house.villageId ? String(house.villageId) : '';
			}
		},
		mounted() {
			//默认带出当前登录用户姓名,联系方式留空由用户自己填写
			this.form.name = this.userInfo.trueName || '';
			//重新拉一次用户信息,保证姓名/小区id是最新的
			this.$axios.get('/api/v2/wechat/user/userInfo', {
				params: {}
			}).then(res => {
				if (res && res.houses) {
					this.changeUserinfo(res);
					this.form.name = this.userInfo.trueName || '';
				}
			}).catch(() => {});
			//问题类型字典
			this.$axios.get('/api/v1/tsjy/dicts').then(res => {
				if (res && res.types && res.types.length) {
					this.types = res.types;
					this.form.type = ''; //字典可能变了,重置选中
				}
			}).catch(() => {});
		},
		methods: {
			...mapMutations(['changeUserinfo']),
			goHistory() {
				this.$router.push('/yjfklist');
			},
			chooseType(item) {
				this.form.type = item.id;
			},
			//上传截图的接口
			afterRead(file) {
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				data.append('moduleCode', 'tsjy_complaint');
				data.append('moduleName', '投诉建议');
				file.status = 'uploading';
				file.message = '上传中...';
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				};
				this.$axios.post('/api/v1/common/upload', data, config)
					.then(result => {
						if (result.id) {
							file.srcs = result.webUrl;
							file.status = 'done';
							file.message = '';
							file.id = result.id;
						} else {
							this.$toast.fail('图片上传失败，请重试！');
							file.status = 'failed';
							file.message = '上传失败';
						}
					})
			},
			onSubmit() {
				if (!this.canSubmit) return;
				if (!this.form.name.trim()) {
					this.$toast('获取不到您的姓名，请先在个人信息中完善');
					return;
				}
				if (!this.form.contact.trim()) {
					this.$toast('请填写联系方式');
					return;
				}
				if (!/^1\d{10}$/.test(this.form.contact)) {
					this.$toast('请输入正确的手机号');
					return;
				}
				if (this.attachs.some(f => f.status === 'uploading')) {
					this.$toast('图片正在上传，请稍候');
					return;
				}
				if (!this.villageId) {
					this.$toast('获取不到您的小区信息，请先完成房屋认证');
					return;
				}
				const attachs = this.attachs.filter(f => f.status === 'done' && f.id).map(f => {
					return { id: f.id };
				});
				this.$axios.post('/api/v1/tsjy', {
					type: this.form.type,
					name: this.form.name,
					mobile: this.form.contact,
					content: this.form.content,
					villageId: this.villageId,
					attachs: attachs
				}).then(() => {
					this.$toast.success('提交成功，感谢您的反馈！');
					//重置表单
					this.form.type = '';
					this.form.content = '';
					this.attachs = [];
				}).catch(() => {
					this.$toast.fail('提交失败，请稍后重试');
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.yjfk-page {
		min-height: 100vh;
		background: #f6f6f7;
		padding: 15px 15px 30px;
		box-sizing: border-box;
	}

	.card {
		background: #fff;
		border-radius: 8px;
		padding: 15px;
	}

	.menu-card {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 15px;
		font-size: 15px;
		color: #323233;

		.menu-left {
			display: flex;
			align-items: center;
		}

		.menu-icon {
			font-size: 18px;
			color: #00b5ff;
			margin-right: 8px;
		}

		.menu-arrow {
			color: #c8c9cc;
		}
	}

	.sec {
		margin-bottom: 20px;

		&:last-child {
			margin-bottom: 0;
		}
	}

	.sec-title {
		font-size: 15px;
		color: #323233;
		font-weight: bold;
		margin-bottom: 12px;

		.req {
			color: #ee0a24;
			margin-right: 2px;
		}

		.count {
			font-size: 12px;
			color: #969799;
			font-weight: normal;
			margin-left: 4px;
		}
	}

	.tags {
		display: flex;
		flex-wrap: wrap;

		.tag {
			padding: 6px 16px;
			border-radius: 4px;
			font-size: 13px;
			color: #969799;
			background: #fff;
			border: 1px solid #e5e5e5;
			margin: 0 10px 10px 0;

			&.active {
				color: #fff;
				background: #00b5ff;
				border-color: #00b5ff;
			}
		}
	}

	.content-field {
		background: #f7f8fa;
		border-radius: 6px;
		padding: 10px;
	}

	.contact-row {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.phone {
			font-size: 15px;
			color: #323233;

			&.empty {
				color: #c8c9cc;
			}
		}

		.edit-icon {
			color: #969799;
			font-size: 16px;
		}
	}

	.contact-field {
		background: #f7f8fa;
		border-radius: 6px;
	}

	.submit-wrap {
		margin: 20px 0;
	}

	.btn-gray {
		background: #d8d8d8;
		color: #fff;
		border: none;
	}
</style>
